export const twoDecimalDigitsOrNone = (number) => {
  return parseFloat(number).toFixed(2).replace(/\D00$/, '')
}
